import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { QuickHeader } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/QuickHeader';
import { HeaderMainLinks } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/headerMainLinks/HeaderMainLinks';
import { HeaderWrapperList } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/headerWrapperList/HeaderWrapperList';
import { HamburgerMenu } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/hamburgerMenu/HamburgerMenu';
import { HeaderMainLogo } from 'src/domains/layouts/webview/components/HeaderMainLogo';
import { UnreadCount } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/QuickHeader.style';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { useState } from 'react';
import { computed, makeObservable, observable } from 'mobx';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { LanguageSwitcher } from 'src/domains/layouts/webview/components/languageSwitcher/LanguageSwitcher';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { HeaderMainLogoWrapper } from './LayoutSkeleton.style';

interface PropsType {
    currentView: RouteViewType;
    accountView: RightHandSideViewType | null;
}

class State {
    @observable public ref: HTMLElement | null = null;

    public setRef = (ref: HTMLElement | null): void => {
        this.ref = ref;
    };

    public constructor() {
        makeObservable(this);
    }

    @computed public get refWidth(): number {
        return this.ref?.clientWidth ?? 0;
    }
}

export const Header = observer('Header', (props: PropsType) => {
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const starRouter = StarRouter.get(common);
    const { closureModeWithLogin, languagesAvailable, closureMode, midnightMigrationScreen } =
        ConfigComponents.get(common).config;

    const isLHSOpened = starRouter.isAccountParam;
    const isClosing = closureModeWithLogin || midnightMigrationScreen;
    const isAlreadyClosed = closureMode;
    const routeName = props.currentView.name;
    const shouldShowLanguageSwitcher = languagesAvailable.length > 1;
    const isAnyCasino = routeName === 'casino' || routeName === 'virtuals' || routeName === 'live-casino';
    const isErrorPage = routeName === 'error';
    const [state] = useState(() => new State());
    const isDesktop = breakpointsState.desktop.isBiggerOrEq ?? false;
    const shouldHidePicker = isDesktop === false || isLHSOpened || shouldShowLanguageSwitcher === false;
    if (isAlreadyClosed) {
        return null;
    }
    if (isClosing) {
        if (breakpointsState.desktop.isBiggerOrEq !== false) {
            return null;
        }
        return (
            <HeaderWrapperList>
                <HeaderMainLogoWrapper>
                    <HeaderMainLogo />
                </HeaderMainLogoWrapper>
                <QuickHeader
                    isAnyCasino={isAnyCasino}
                    accountView={props.accountView}
                    currentView={props.currentView}
                />
            </HeaderWrapperList>
        );
    }

    return (
        <HeaderWrapperList>
            <HamburgerMenu />
            <HeaderMainLogo />

            {breakpointsState.largeDesktop.isBiggerOrEq === false ? null : (
                <HeaderMainLinks
                    currentView={props.currentView}
                    languageWidth={shouldShowLanguageSwitcher === false ? 0 : state.refWidth}
                />
            )}
            {shouldHidePicker ? null : (
                <LanguageSwitcher
                    reference={null}
                    setRef={state.setRef}
                    isSidebar={false}
                />
            )}

            {!isErrorPage &&
                (breakpointsState.desktop.isBiggerOrEq === false ? (
                    <QuickHeader
                        isAnyCasino={isAnyCasino}
                        accountView={props.accountView}
                        currentView={props.currentView}
                    />
                ) : null)}
        </HeaderWrapperList>
    );
});

export { HeaderMainLinks, UnreadCount };
